import { ContactLink } from '@components/ContactLink';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const ContactLinkSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Contact Link"
      description="A clickable link component with social icon, label, and external link indicator on hover. Opens in new tab."
      figmaNodeId="356-3875"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Default</h3>
      <div className={styles.contactLinkContainer}>
        <ContactLink href="https://linkedin.com/in/example" label="LinkedIn" provider="linkedin" />
      </div>
      <p className={styles.hint}>Hover to see the external link icon appear.</p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>All Social Providers</h3>
      <div className={styles.contactLinkGrid}>
        <ContactLink href="https://facebook.com/example" label="Facebook" provider="facebook" />
        <ContactLink href="https://instagram.com/example" label="Instagram" provider="instagram" />
        <ContactLink href="https://linkedin.com/in/example" label="LinkedIn" provider="linkedin" />
        <ContactLink href="https://tiktok.com/@example" label="TikTok" provider="tiktok" />
        <ContactLink href="https://wa.me/1234567890" label="WhatsApp" provider="whatsapp" />
        <ContactLink href="https://x.com/example" label="X (Twitter)" provider="x" />
        <ContactLink href="https://youtube.com/@example" label="YouTube" provider="youtube" />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Disabled State</h3>
      <div className={styles.contactLinkContainer}>
        <ContactLink
          href="https://linkedin.com/in/example"
          label="LinkedIn (Disabled)"
          provider="linkedin"
          disabled
        />
      </div>
      <p className={styles.hint}>Disabled links have reduced opacity and no hover effects.</p>
    </div>
  </section>
);
